// Web Push subscription utilities
// Requires: REACT_APP_VAPID_PUBLIC_KEY and REACT_APP_API_BASE_URL

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

function urlBase64ToUint8Array(base64String) {
  try {
    if (!base64String || typeof base64String !== 'string') return null;
    // Trim and remove surrounding quotes if present
    let cleaned = base64String.trim().replace(/^"|"$/g, '').replace(/^'|'$/g, '');
    // Validate allowed base64url characters
    const valid = /^[A-Za-z0-9_\-]+={0,2}$/.test(cleaned) || /^[A-Za-z0-9_\-]+$/.test(cleaned);
    if (!valid) {
      console.warn('VAPID public key has invalid characters. Ensure it\'s URL-safe Base64 (RFC 4648).');
    }
    const padding = '='.repeat((4 - (cleaned.length % 4)) % 4);
    const base64 = (cleaned + padding)
      .replace(/-/g, '+')
      .replace(/_/g, '/');
    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);
    for (let i = 0; i < rawData.length; ++i) {
      outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
  } catch (err) {
    console.error('Invalid VAPID key format; failed to decode Base64:', err);
    return null;
  }
}

export async function registerServiceWorker() {
  if (!('serviceWorker' in navigator)) return null;
  try {
    const reg = await navigator.serviceWorker.register('/sw.js');
    return reg;
  } catch (e) {
    console.error('SW registration failed', e);
    return null;
  }
}

export async function ensureNotificationPermission() {
  if (!('Notification' in window)) return false;
  if (Notification.permission === 'granted') return true;
  if (Notification.permission === 'denied') return false;
  try {
    const perm = await Notification.requestPermission();
    return perm === 'granted';
  } catch {
    return false;
  }
}

export async function subscribePush(reg) {
  try {
    const vapidPublicKey = process.env.REACT_APP_VAPID_PUBLIC_KEY;
    if (!vapidPublicKey) {
      console.warn('Missing REACT_APP_VAPID_PUBLIC_KEY');
      return null;
    }
    const appServerKey = urlBase64ToUint8Array(vapidPublicKey);
    if (!appServerKey) {
      console.warn('Cannot subscribe to push: VAPID key is invalid.');
      return null;
    }
    const sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: appServerKey,
    });
    return sub;
  } catch (e) {
    console.error('Push subscribe failed', e);
    return null;
  }
}

export async function sendSubscriptionToServer(subscription, token, userEmail) {
  if (!API_BASE_URL) {
    console.warn('Missing REACT_APP_API_BASE_URL for sending subscription');
    return false;
  }
  try {
    const res = await fetch(`${API_BASE_URL}/auth/user/push/subscribe`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(token ? { 'Authorization': `Bearer ${token}` } : {}),
        ...(userEmail ? { 'user-info': userEmail } : {}),
      },
      body: JSON.stringify(subscription),
    });
    return res.ok;
  } catch (e) {
    console.error('Failed to send subscription to server', e);
    return false;
  }
}
